"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var react_i18next_1 = require("react-i18next");
var react_i18next_2 = require("react-i18next");
var useBackWarning_1 = __importDefault(require("../../hook/useBackWarning"));
var PaymentFailed_module_scss_1 = __importDefault(require("./PaymentFailed.module.scss"));
var PaymentFailed = function () {
    var t = (0, react_i18next_2.useTranslation)().t;
    (0, useBackWarning_1.default)(t("BACK_WARNING_PAYMENT_RESULT"));
    return ((0, jsx_runtime_1.jsx)("main", { className: PaymentFailed_module_scss_1.default.failedPage, children: (0, jsx_runtime_1.jsxs)("section", { className: PaymentFailed_module_scss_1.default.failedCard, children: [(0, jsx_runtime_1.jsx)("h1", { className: PaymentFailed_module_scss_1.default.failedTitle, children: t("PAYMENT_FAILED_TITLE") }), (0, jsx_runtime_1.jsx)("p", { className: PaymentFailed_module_scss_1.default.failedText, children: t("PAYMENT_FAILED_TEXT") })] }) }));
};
exports.default = (0, react_i18next_1.withTranslation)()(PaymentFailed);
